/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import ReactPhoneInput from 'react-phone-input-2'
import * as app from "../services/AppService";
import  ar  from 'react-phone-input-2/lang/ar.json';
import tr from 'react-phone-input-2/lang/tr.json';
import { useSelector } from "react-redux"
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';
//https://github.com/bl00mber/react-phone-input-2  documentation

interface Props extends RowItem, Omit<InterfaceComponentsProps, "Class" | "Icon" | "isTable"> {
    model: any;
    onChange?: (...args: any) => any;
    country?: string;
    elmKey?: string;
}
//#region
var countriesMasks = {
    "us": "(...)-...-....",        // الولايات المتحدة
    "ca": "(...)-...-....",        // كندا
    "mx": "(..) ... ....",       // المكسيك
    "br": "(..) .....-....",      // البرازيل
    "ar": "(...)-....-....",      // الأرجنتين
    "co": "(...) ... ....",       // كولومbia

    "gb": "(...)-..-..-...",      // المملكة المتحدة
    "fr": "(.) .. .. .. ..",      // فرنسا
    "de": "(...)-.......",        // ألمانيا
    "it": "(..) ....-....",       // إيطاليا
    "es": "(...) .. .. ..",       // إسبانيا
    "nl": "(..) .... ....",       // هولندا
    "be": "(...) .. .. ..",       // بلجيكا
    "se": "(..) ... ....",        // السويد
    "pl": "(..) ... ....",        // بولندا
    "ru": "(...) ... .. ..",      // روسيا
    "ch": "(..) ... .. ..",       // سويسرا
    "at": "(...) ... ....",       // النمسا

    "cn": "(...) .... ....",      // الصين
    "jp": "(.) ....-....",        // اليابان
    "kr": "(..) ... ....",        // كوريا الجنوبية
    "in": "(...)-...-....",      // الهند
    "id": "(...)-....-....",      // إندونيسيا
    "th": "(...)-...-...",        // تايلاند
    "vn": "(...)-...-...",        // فيتنام
    "my": "(...)-....-...",       // ماليزيا
    "sg": "(....) ....",          // سنغافورة
    "ph": "(...) .......",        // الفلبين
    "pk": "(...)-....-....",      // باكستان
    "bd": "(...)-...-...",        // بنغلاديش

    "dz": "(...)-...-...",       // الجزائر
    "bh": "(...)-....",          // البحرين
    "eg": "(...)-...-....",      // مصر
    "iq": "(...) ...-..-..",     // العراق
    "jo": "(.)-....-....",       // الأردن
    "kw": "(..)-..-....",        // الكويت
    "lb": "(...) ...-...-...",        // لبنان
    "ly": "(...)-...-...",       // ليبيا
    "ma": "(...)-...-...",       // المغرب
    "om": "(...)-....",          // عمان
    "ps": "(...)-....",          // فلسطين
    "qa": "(..)-..-....",        // قطر
    "sa": "(...)-...-...",       // المملكة العربية السعودية
    "sd": "(...)-....",          // السودان
    "sy": "(...) ...-...",       // سوريا
    "tn": "(...)-...-...",       // تونس
    "ae": "(...)-...-...",       // الإمارات العربية المتحدة
    "ye": "(...)-...-...",       // اليمن
    "mr": "(..)-..-....",        // موريتانيا


    "af": "(...)-...-...",        // أفغانستان
    "al": "(...)-..-...",        // ألبانيا
    "am": "(..)-..-...",         // أرمينيا
    "az": "(...)-...-...",        // أذربيجان
    "bs": "(...)-...-....",      // جزر البهاما
    "by": "(...)-...-...",       // بيلاروسيا
    "bj": "(...)-...-...",       // بنين
    "bt": "(...)-..-...",        // بوتان
    "bo": "(...)-...-...",       // بوليفيا
    "ba": "(...)-..-...",        // البوسنة والهرسك
    "bw": "(...)-...-...",       // بوتسوانا
    "bn": "(...)-...-...",       // بروناي
    "bg": "(...)-...-...",       // بلغاريا
    "cv": "(...)-...-...",       // الرأس الأخضر
    "kh": "(...)-...-...",       // كمبوديا
    "cm": "(...)-...-...",       // الكاميرون
    "cr": "(...)-...-...",       // كوستاريكا
    "hr": "(...)-...-...",       // كرواتيا
    "cy": "(...)-..-...",       // قبرص
    "cz": "(...)-...-...",       // التشيك
    "dk": "(..)-...-....",       // الدنمارك
    "er": "(...)-...-...",       // إريتريا
    "ee": "(...)-...-...",       // إستونيا
    "fi": "(...)-...-...",       // فنلندا
    "gr": "(...)-...-....",      // اليونان
    "ge": "(...)-...-...",       // جورجيا
    "hn": "(...)-...-...",       // هندوراس
    "hu": "(...)-...-...",       // المجر
    "is": "(...)-...-...",       // أيسلندا
    "ir": "(9..)-...-....",      // إيران
    "ie": "(...)-...-...",       // أيرلندا
    "il": "(5..)-...-...",       // إسرائيل
    "kz": "(...)-...-...",       // كازاخستان
    "ke": "(...)-...-...",       // كينيا
    "kg": "(...)-..-...",        // قيرغيزستان
    "la": "(...)-..-...",        // لاوس
    "lv": "(...)-..-...",        // لاتفيا
    "lt": "(...)-..-...",        // ليتوانيا
    "lu": "(...)-...-...",      // لوكسمبورغ
    "md": "(...)-..-...",        // مولدوفا
    "mm": "(...)-...-...",       // ميانمار
    "na": "(...)-...-...",       // ناميبيا
    "nr": "(...)-...",           // ناورو
    "np": "(...)-...-....",      // نيبال
    "ni": "(...)-...-...",       // نيكاراغوا
    "ng": "(...)-...-....",      // نيجيريا
    "no": "(..)-...-....",       // النرويج
    "pa": "(...)-...-...",       // بنما
    "py": "(...)-...-...",       // باراغواي
    "pe": "(...)-...-...",       // بيرو
    "pt": "(...)-...-...",       // البرتغال
    "ro": "(...)-...-...",       // رومانيا
    "rw": "(...)-...-...",       // رواندا
    "si": "(...)-...-...",       // سلوفينيا
    "sk": "(...)-...-...",       // سلوفاكيا
    "lk": "(...)-...-....",      // سريلانكا
    "sz": "(...)-...-...",       // إيسواتيني
    "ug": "(...)-...-...",       // أوغندا
    "ua": "(...)-...-...",       // أوكرانيا
    "uy": "(...)-...-...",       // أوروغواي
    "uz": "(...)-...-...",       // أوزبكستان
    "ve": "(...)-...-...",       // فنزويلا
    "zm": "(...)-...-...",       // زامبيا
    "zw": "(...)-...-...",        // زيمبابوي
    "ci": "(...)-..-..-...",        // زيمبابوي
}


//#endregion
export default function PhoneInput(props: Props) {
    const defaultCountry = useSelector((store: any) => store.data.options.FirstCountryCode) || "90";
    const wrapperRef = useRef<HTMLDivElement | null>(null);

    const [model, setModel] = useState({
        dialCode: "",
        number: "",
        country: props.country
    });
    function clearNum(num: string): string {
        return num && num.length > 0 && +num[0] === 0 ? clearNum(num.substring(1)) : num;
    }

    useEffect(() => {
        let newVal = clearNum(props.model)
        setModel(old => ({ ...old, number: newVal ? newVal : model.dialCode ? model.dialCode : defaultCountry, }));
    }, [props.model])

    useEffect(() => {
        setModel(old => ({ ...old, country: props.country ? props.country.toLowerCase() : "" }))
    }, [props.country])

    function handler(value: string, data: any, event: any, formattedValue: string) {
        let number = value === data.dialCode ? "" : value;
        setModel(old => ({ ...old, number: value, dialCode: data.dialCode }))
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(number, props.elmKey);
    }
    function blured(event: any, data: any) {
        const { value } = event.target;
        if (app.options().IsCentralBank === 1 && value.length !== data.format.length && value.length < 20 && data.countryCode !=="lb") {
            setModel(old => {
                let number = model.dialCode ? model.dialCode : defaultCountry
                if (props.onChange && typeof (props.onChange) == "function")
                    props.onChange(number, props.elmKey);
                return { ...old, number };
            });
        }
    }
    //! UseEffect to Fix Country-List:
    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) return;

        const dropDirection = () => {
            const dropdown = wrapper.querySelector(".country-list") as HTMLElement | null;
            if (!dropdown) return;

            // Calculate position When Dropdown appears:
            const rect = wrapper.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;

            // Determine if should drop up
            const shouldDropUp = spaceBelow < spaceAbove;

            // Apply classes
            dropdown.classList.toggle("drop-up", shouldDropUp);
            dropdown.classList.toggle("drop-down", !shouldDropUp);
        };

        const observer = new MutationObserver(dropDirection);
        observer.observe(wrapper, { childList: true, subtree: true, attributes: true });

        // Also run on window resize
        const handleResize = () => {
            const dropdown = wrapper.querySelector(".country-list") as HTMLElement | null;
            if (dropdown) dropDirection();
        };

        //! Add the Event to the Window:
        window.addEventListener("resize", handleResize);

        //! clean the effect: 
        return () => {
            observer.disconnect();
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div ref={wrapperRef}>
            <label className={`fw-semibold ms-1 ${props.labelClass}`}>{app.translate(props.label)}</label>
            <ReactPhoneInput countryCodeEditable={false} enableSearch
                localization={app.translate("Lang") === "ar" ? ar : app.translate("Lang") === "tr" ? tr : undefined}
                country={model.country} value={model.number}
                // name="phone"
                containerClass="h-50 "
                masks={countriesMasks}
                buttonClass=" rounded-start " inputClass="w-100 height-31 rounded-2 bg-body-tertiary focus-group "
                inputProps={{
                    style: { direction: 'ltr' },
                    id: props.id ? props.id : "phon" + props.label,
                }}
                disabled={props.disabled}
                onBlur={blured}
                onChange={handler} />
        </div>
    );
}

PhoneInput.defaultProps = {
    labelClass: "text-primary-emphasis ",
}
